<template>
    <div>
        <div v-if="!isModify">
            <ViewInfo :userInfo="userInfo" @changeStatus="changeStatus"/>
        </div>
        <div v-else>
            <ModifyInfo :userInfo="userInfo" @changeStatus="changeStatus"/>
        </div>
    </div>
</template>

<script>
import "../../../../../assets/css/login.css";
import { mapState, mapActions } from "vuex";
import ViewInfo from "./ViewInfo";
import ModifyInfo from "./ModifyInfo";
import EventBus from "@/js/eventbus/eventBus";
export default {
    data() {
        return {
            userInfo : null,
            isModify : false,
            error: false,
            dBHeight: {
                'min-height': (window.innerHeight - 153) + 'px',
            },
        }
    },
    components : {
        ViewInfo,
        ModifyInfo
    },
    created() {
        this.getMyInfo();
        //this.getUserPhoto();
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        getMyInfo() {
            let obj = this;
            let reqData = {
                url: "/api/auth/org/getMyInfo",
                method: "post",
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.result !== null) {
                    if(res.result.errorCode !== undefined) {

                    } else {
                        obj.userInfo = null;
                        let userName = obj.$i18nUtil.getLanguage() !== 'ko' && res.result.userNameEn != null ? res.result.userNameEn : res.result.userName;
                        let parterName = obj.$i18nUtil.getLanguage() !== 'ko' && res.result.partnerNameEn != null ? res.result.partnerNameEn : res.result.partnerName;

                        let info = {
                            email : res.result.email,
                            userName : userName,
                            remainDay : res.result.remainDay,
                            cellPhoneNo : res.result.cellPhoneNo,
                            partnerName : parterName,
                        };
                        obj.userInfo = info;
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        async changeStatus(payload) {
            await this.getMyInfo();
            this.isModify = payload.isModify;
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/common/myInfo/external/ExternalUserInfo.vue